import { ScrollView } from "devextreme-react";
import { Popup } from "devextreme-react/popup";
import { TabPanel, Item as TabPanelItem } from "devextreme-react/tab-panel";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/auth";
import { useScreenSize } from "../../utils/media-query";
import GeneralDataProtectionRegulationContent from "../general-data-protection-regulation-acceptance-popup/GeneralDataProtectionRegulationContent";
import ProcessingOfEmailAddressForCivilLawContractorContent from "../processing-of-email-address-acceptance-popup/ProcessingOfEmailAddressForCivilLawContractorContent";
import ProcessingOfEmailAddressForFullTimeEmployeeContent from "../processing-of-email-address-acceptance-popup/ProcessingOfEmailAddressForFullTimeEmployeeContent";
import TermsOfUseContent from "../terms-of-use-acceptance-popup/TermsOfUseContent";

type RegulationsPopupProps = {
  visible: boolean;
  onClose: () => void;
};

export default function RegulationsPopup({
  visible,
  onClose,
}: RegulationsPopupProps) {
  const { t } = useTranslation();
  const { isXSmall, isSmall } = useScreenSize();
  const isMobile = isXSmall || isSmall;
  const { user } = useAuth();

  return (
    <Popup
      visible={visible}
      onHiding={onClose}
      showCloseButton
      title={t("regulations.title")}
      width={isMobile ? "100%" : 720}
      height={isMobile ? "100%" : 560}
    >
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <TabPanel
          animationEnabled
          swipeEnabled={isMobile}
          height="100%"
          deferRendering={false}
        >
          <TabPanelItem title={t("regulations.tabs.rules")}>
            <ScrollView useNative>
              <TermsOfUseContent />
            </ScrollView>
          </TabPanelItem>
          <TabPanelItem title={t("regulations.tabs.gdpr")}>
            <ScrollView useNative>
              <GeneralDataProtectionRegulationContent />
            </ScrollView>
          </TabPanelItem>
          <TabPanelItem title={t("regulations.tabs.emailSharing")}>
            <ScrollView useNative>
              {user?.contractType === 1 ? (
                <ProcessingOfEmailAddressForCivilLawContractorContent />
              ) : (
                <ProcessingOfEmailAddressForFullTimeEmployeeContent />
              )}
            </ScrollView>
          </TabPanelItem>
        </TabPanel>
      </div>
    </Popup>
  );
}
